import React, { useRef, useState, useEffect } from 'react';

export default function Timer({ timeOut }) {

    const [min, setMin] = useState("03");
    const [sec, setSec] = useState("00");
    const time = useRef(180);
    const timerId = useRef(null);

    useEffect(() => {
        timerId.current = setInterval(() => {
            setMin(parseInt(time.current / 60) < 10 ? "0" + parseInt(time.current / 60) : parseInt(time.current / 60));
            setSec(time.current % 60 < 10 ? "0" + time.current % 60 : time.current % 60);
            time.current -= 1;
        }, 1000);

        return () => clearInterval(timerId.current);
    }, []);

    useEffect(() => {
        // 만약 타임 아웃이 발생했을 경우
        if (time.current <= 0) {
            setTimeout(() => {
                console.log("타임 아웃");
                clearInterval(timerId.current);
                // dispatch event
                timeOut(false);
            }, 1000)
        }
    }, [sec]);

    return (
        <div className="timer_box">
            <p>{min}:{sec}</p>
        </div>
    );
}